import { CommonModule, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NavService } from '../../../services/nav.service';
import { HelpersService } from '../../../services/helpers.service';
import { PermissionsService } from '../../../services/permissions.service';
import * as Global from '../../../global'
import { ExpenseService } from '../../../services/expense.service';
import { TripService } from '../../../services/trip.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
@Component({
  selector: 'app-side-nav',
  standalone: true,
  imports: [RouterModule, CommonModule, NgIf, MatTooltipModule, MatIconModule, MatButtonModule],
  templateUrl: './side-nav.component.html',
  styleUrl: './side-nav.component.scss',
})
export class SideNavComponent {
  Global = Global
  @Input() isNavOpen: boolean = true;
  @Input() isMobileNavOpen: boolean = false;
  @Input() isMobileNav: boolean = false;
  view_type: any = null;
  nav_list: any = [];
  claims: any = [];
  claimTypes: any = [];
  constructor(
    private route: ActivatedRoute,
    private tripService: TripService,
    private expenseService: ExpenseService,
    private navService: NavService,
    public helpers: HelpersService,
    private permissions: PermissionsService
  ) { }
  async ngOnInit() {
    this.claims = await this.permissions.getAllClaims();
    this.view_type = this.helpers.role();
    this.nav_list = this.navService.NavList();
    this.claims.forEach((claim: any) => {
      this.claimTypes.push(claim.claimType);
    });
  }
  toogleNav() {
    this.navService.updateNav(!this.isNavOpen);
  }
  hasNavClaim(claimType: any): boolean {
    if (!claimType) {
      return false;
    }
    return Array.isArray(claimType)
      ? claimType.some((c: string) => this.claimTypes.includes(c))
      : this.claimTypes.includes(claimType);
  }
  toogleMobileMenu() {
    this.navService.setIsMobileNavOpen(!this.isMobileNavOpen);
    this.expenseService.clearData()
    this.tripService.clearData()
  }
}
